export default () => (
    <div className="loader">
        <div className="preloader pl-lg pls-blue plc-path">
            <svg className="pl-circular" viewBox="25 25 50 50">
                <circle className="plc-path" cx="50" cy="50" r="20" />
            </svg>

            <p>Loading...</p>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./app/components/loader.jsx